module.exports = __webpack_public_path__ + "img/stock0.94f32e91.png";